import { IResourceConfig } from '@/Core/Contracts/UI'
import { DictionariesShell } from '../Components/DictionariesShell/DictionariesShell'
import { ClusterViewTemplate } from '../Templates/ClusterViewTemplate/ClusterViewTemplate'
import { dictionaryDeleteConfirmText, dictionaryDetailButtons } from '../Helpers/dictionaryDelete'

export const ListClusterResource: IResourceConfig = {
    title: 'Кластери',
    fields: {
        id: {
            label: 'ID',
            type: 'number',
            inputProps: { disabled: true },
            /** У фільтрі: оператор (=, >, ≥, <, ≤) або діапазон від–до */
            isFilterRange: true,
        },
        title: {
            label: 'Назва',
            isRequired: true,
            type: 'string',
        },
        isActive: {
            label: 'Активний',
            type: 'switch',
        },
        code: {
            label: 'Код',
            isRequired: true,
            type: 'string',
            depFn: ({ formContext, field }) => {
                field.mergeInputProps({ disabled: formContext.values?.id > 0 })
            },
        },
        externalCode: {
            label: 'Унікальний код ERP',
            type: 'string',
        },
        sorting: {
            label: 'Сортування',
            type: 'number',
        },
    },
    filter: {
        includeFields: ['id', 'title', 'code', 'isActive', 'externalCode'],
    },
    /** Перегляд картки: поля + список регіонів кластера; створення й редагування — стандартна форма */
    detailConfig: {
        /** «Видалити» в шапці картки (ядро дає лише пункт у меню рядка) */
        onButtons: dictionaryDetailButtons,
        modeConfig: {
            view: {
                template: ClusterViewTemplate,
            },
        },
    },
    /** Картка колекції всередині оболонки розділу «Довідники» */
    layout: DictionariesShell,
    restUrl: '/services/lists/clusters',
    pageUrl: '/settings/clusters',
    primaryFieldCode: 'code',
    settings: {
        /** Попередження в підтвердженні видалення запису з ERP */
        deleteConfirmText: dictionaryDeleteConfirmText,
        searchFields: ['id', 'code', 'title'],
    },
}
